import * as React from 'react'
import { css } from 'glamor'

interface IBlockquoteRendererProps {
  children?: React.ReactNode
}

export default function BlockquoteRenderer({ children }: IBlockquoteRendererProps) {
  return (
    <blockquote
      {...css({
        borderLeft: '2px solid #eee',
        paddingLeft: '1em',
      })}
    >
      {children}
    </blockquote>
  )
}
